import React, { useState, useEffect, forwardRef,useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import './GenerateFormModel.css'
import '../../../../reUsableTemplates/EditableTable/EditableTable.css'
import download_icon from '../../../../../assets/reUsableTemplates_assets/dowload_icon.png';
import selected_icon from '../../../../../assets/reUsableTemplates_assets/selected_icon.png';
import action_icon from "../../../../../assets/reUsableTemplates_assets/action.png"
import slno_icon from "../../../../../assets/reUsableTemplates_assets/slno.png"
import downloadIcon from "../../../../../assets/register_assets/generatedForms/downloadIcon.png"
import arrow_up from "../../../../../assets/reUsableTemplates_assets/arrow_up.png"
import arrow_down from "../../../../../assets/reUsableTemplates_assets/arrow_down.png"
import financial_year from "../../../../../assets/register_assets/inputMatix/financial_year.png"

import { downloadAllSelectedIDsRecords } from '../../../../../services/global_redux/globale_actions/Download.action';
import { FaEye, FaRegFileAlt, FaRegCheckCircle } from "react-icons/fa";

import {getInputMatrixActivities } from '../../../../../services/register_redux/register_actions/Form.action';
function GeneratedFormsModel({mainIcon, title ,header, data, setLoading , date ,showSnackbar ,handleDownloadClick, handleZipDownload, handleViewPdfClick, handleViewExcelClick, handleReleaseClick, handleBulkRelease, zipBusy, itemNoun = "form"}) {
    const isClient =
      JSON.parse(sessionStorage.getItem("user") || "{}")?.base_role === "Client";
    const [checkedItems, setCheckedItems] = useState({});
    const dispatch = useDispatch();
    const [checkedItemCount, setCheckedItemCount] = useState(0);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage, setRecordsPerPage] = useState(10);
    const [isAllChecked, setIsAllChecked] = useState(false);
    const containerRef = useRef(null);
      const [isScrollable, setIsScrollable] = useState(false);
      const [showTooltip, setShowTooltip] = useState(false);
      const [searchQuery, setSearchQuery] = useState("");
      
    const [monthFilterList,setMonthFilterList] = useState([]);
    const [yearFilterList,setYearFilterList] = useState([]);
    const [allMonthsData, setAllMonthsData] = useState([]);
    const [selectedYear, setSelectedYear] = useState('');
    const [selectedMonth, setSelectedMonth] = useState('');
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];


      const handleSort = (key) => {
        setSortConfig((prev) => ({
            key,
            direction: prev.key === key && prev.direction === "asc" ? "desc" : "asc",
        }));
    };
    
    const getSortIcon = (key) => {
        if (sortConfig.key !== key) return "";
        return sortConfig.direction === "asc" ? arrow_up : arrow_down;
    };
    const filteredData = data.filter(item =>
      Object.values(item).some(value =>
        String(value).toLowerCase().includes(searchQuery.toLowerCase())
      )
    );
    const sortedData = [...filteredData].sort((a, b) => {
      if (!sortConfig.key) return 0;
      const aVal = a[sortConfig.key];
      const bVal = b[sortConfig.key];
      if (aVal < bVal) return sortConfig.direction === "asc" ? -1 : 1;
      if (aVal > bVal) return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    });
    // pagination
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = sortedData.slice(indexOfFirstRecord, indexOfLastRecord);
    const totalPages = Math.ceil(sortedData.length / recordsPerPage);
    const current_month = date;
    const handlePageChange = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };
    const getPageSizeOptions = (totalEntries) => {
      const options = [ 10, 20, 50, 100,200,300,400,500,600,];
      const filtered = options.filter(size => size < totalEntries);
    
      return [...filtered, totalEntries];
    };
    
const handleDownloadSelected = () =>{
    if (typeof handleZipDownload === "function") {
      const selectedIds = Object.entries(checkedItems)
        .filter(([, on]) => on)
        .map(([id]) => id);
      if (!selectedIds.length) {
        showSnackbar("select the row", "warning");
        return;
      }
      if (selectedIds.length === 1 && typeof handleDownloadClick === "function") {
        handleDownloadClick(selectedIds[0]);
        return;
      }
      handleZipDownload(selectedIds);
      return;
    }
    if (checkedItemCount == 0) {
      showSnackbar("select the row", 'warning');
  } else{
    
    const itemDatas = data;
    if(title == 'Branch Holidays') {
      const selectedIds = Object.keys(checkedItems).filter(id => checkedItems[Number(id)]).map(id => Number(id));
      let storedId = [];
      let storedHoliId = [];
      selectedIds.forEach(datas => {
          const item = itemDatas.find(d => d.id === datas);
          storedId.push(item.row_id);
          storedHoliId.push(item.old_id);
      });
  
      const client_id = sessionStorage.getItem('selectedClient')
      const data = {
          client_id: client_id,
          current_month: current_month,
          titleName: title,
          selectedIds: storedHoliId,
          ids: storedId
      }
      submitdownload(data);
    } else {
        const selectedIds = Object.keys(checkedItems).filter(id => checkedItems[Number(id)]).map(id => Number(id));
        const client_id = sessionStorage.getItem('selectedClient')
        const data = {
            client_id: client_id,
            current_month: current_month,
            titleName: title,
            selectedIds: selectedIds
        }
        submitdownload(data);
    }
  }
    
  }
  
useEffect(() => {
    const allChecked = sortedData.length > 0 && sortedData.every(item => checkedItems[item.id]);
    setIsAllChecked(allChecked);
    const count = Object.values(checkedItems).filter(Boolean).length;
    setCheckedItemCount(count);
    // eslint-disable-next-line react-hooks/exhaustive-deps
}, [checkedItems, data, searchQuery, sortConfig]);
useEffect(() => {
    setCheckedItems({});
    setIsAllChecked(false);
}, [data]);
const submitdownload = async (data) => {
    setLoading(true);
    try {
        const response = await dispatch(downloadAllSelectedIDsRecords(data));
        console.log(response);
        if (response.success == true) {
            showSnackbar("Downloaded Successfully", 'success');
            setLoading(false);
            setCheckedItems({})
        } else {
            showSnackbar(response.error, 'warning');
            setLoading(false);
        }
    } catch (error) {
        showSnackbar('An error occurred', 'error');
        setLoading(false);
    }
}

const handleCheckAll = (e) => {
    const checked = e.target.checked;
    setIsAllChecked(checked);
    if (!checked) {
      setCheckedItems({});
      return;
    }
    const next = {};
    sortedData.forEach((item) => {
      if (item.id != null) next[item.id] = true;
    });
    setCheckedItems(next);
  };

  const selectedRows = sortedData.filter((item) => checkedItems[item.id]);
  const headerReleaseLabel =
    selectedRows.length > 0 && selectedRows.every((item) => item.is_released)
      ? "Re-release"
      : "Release";

  const onBulkReleaseClick = () => {
    if (typeof handleBulkRelease !== "function") return;
    const selectedIds = selectedRows.map((item) => item.id);
    if (!selectedIds.length) {
      showSnackbar(`Select ${itemNoun}s to release.`, "warning");
      return;
    }
    handleBulkRelease(selectedIds);
  };
  
const handleCheckChange = (id) => {
    setCheckedItems(prevCheckedItems => ({
        ...prevCheckedItems,
        [id]: !prevCheckedItems[id]
    }));
  };
  
function formatDate(dateString) {
    const date = new Date(dateString);
  
    if (isNaN(date.getTime())) {
        return dateString;
    }
  
    const options = { day: '2-digit', month: 'short', year: 'numeric' };
    return new Intl.DateTimeFormat('en-GB', options).format(date).replace(/ /g, '-');
  }

  
  const getInputMatrixActivitiesFetch = async () => {
    try {
      const response = await dispatch(getInputMatrixActivities());
      if (response.success === true) {
        const data = response.data.months;
  
        const years = [...new Set(data.map(item => item.split('-')[0]))];
  
        // Set the full data for later filtering
        setAllMonthsData(data);
  
        setYearFilterList(years);
  
        if (years.length > 0) {
          const firstYear = years[0];
  
          const monthsForFirstYear = [...new Set(
            data
              .filter(item => item.split('-')[0] === firstYear)
              .map(item => {
                const monthNum = parseInt(item.split('-')[1], 10);
                return monthNames[monthNum - 1];
              })
          )].sort((a, b) => monthNames.indexOf(a) - monthNames.indexOf(b));
  

        }
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };
  
  useEffect(() => {
    getInputMatrixActivitiesFetch();
  }, [dispatch]);

  useEffect(() => {
    if (selectedYear) {
      const monthsForSelectedYear = [...new Set(
        allMonthsData
          .filter(item => item.split('-')[0] === String(selectedYear))
          .map(item => {
            const monthNum = parseInt(item.split('-')[1], 10);
            return monthNames[monthNum - 1];
          })
      )].sort((a, b) => monthNames.indexOf(a) - monthNames.indexOf(b));
      setMonthFilterList(monthsForSelectedYear);
    } else {
      setMonthFilterList([]);
    }
  }, [selectedYear, allMonthsData]);

  const handleYearChange = (year) => {
    setSelectedYear(year);

    const monthsForSelectedYear = year
      ? [...new Set(
          allMonthsData
            .filter(item => item.split('-')[0] === year)
            .map(item => {
              const monthNum = parseInt(item.split('-')[1], 10);
              return monthNames[monthNum - 1];
            })
        )].sort((a, b) => monthNames.indexOf(a) - monthNames.indexOf(b))
      : [];

    setMonthFilterList(monthsForSelectedYear);
    if (!year) setSelectedMonth('');
  };

  const handleMonthChange = (month) => {
    if (!selectedYear || !month) return;
    const idx = monthNames.indexOf(month);
    if (idx < 0) return;
    setSelectedMonth(month);
    const monthNum = String(idx + 1).padStart(2, '0');
    alert(`${selectedYear}-${monthNum}-01`);
  };
  
  useEffect(() => {
    const checkScrollable = () => {
      if (containerRef.current) {
        const { scrollWidth, clientWidth } = containerRef.current;
        setIsScrollable(scrollWidth > clientWidth);
      }
    };

    checkScrollable(); // run once on mount
    window.addEventListener("resize", checkScrollable); // run on resize
    return () => window.removeEventListener("resize", checkScrollable);
  }, [data]);
    return (
        <div className='container-fluid FormsTable-main-contaner '>
          <div className='row FormsTable-main'>
              <div className="table-header">
                <div className="row d-flex">
                    {/* <form onSubmit={handledeletemultialert} className='p-0 m-0'> */}
                      <div className="col d-flex justify-content-between  pe-1">
                        <div className="title-data d-flex"><div className="table_main_img generatedForms"><img src={mainIcon} alt="noImg" className='dataImg' /></div>
                          <p className="dataTitle">{title} List</p> 
                          <div className="FormsTable-search-box position-relative">
                            <input
                              type="text"
                              className=""
                              placeholder="Search here..."
                              style={{
                                backgroundColor: "#f9fafb",
                                border: "none",
                                width: "250px"
                              }}
                              value={searchQuery}
                              onChange={(e) => setSearchQuery(e.target.value)}
                            />
                            <i
                            className="bi bi-search position-absolute"
                            style={{
                              top: "39%",
                              left: "20px",
                              transform: "translateY(-50%)",
                              color: "#9ca3af"
                            }}
                            ></i>
                          </div>
                        </div>
                        <div className='float-end d-flex align-items-center'>
                          <button
                            type="button"
                            className='formsTable_icon_btn generated-forms-header-zip'
                            onClick={handleDownloadSelected}
                            disabled={!!zipBusy || !sortedData.length}
                            title={checkedItemCount ? `Download ${checkedItemCount} selected` : "select the row"}
                          >
                            <img src={download_icon} alt="noImg" className='download_icon p-0 m-0' />
                          </button>
                            <div className="formsTable_icon_btn" onMouseEnter={() => setShowTooltip(true)} onMouseLeave={() => setShowTooltip(false)}>
                              <img src={selected_icon} alt="" />
                              {showTooltip && (
                                  <div className="tooltipww">
                                      Selected: {checkedItemCount}
                                  </div>
                              )}
                          </div>
                          {typeof handleBulkRelease === "function" && !isClient ? (
                            <button
                              type="button"
                              className="generated-forms-release-btn generated-forms-header-release"
                              onClick={onBulkReleaseClick}
                              disabled={!!zipBusy}
                            >
                              {headerReleaseLabel}
                            </button>
                          ) : null}
                          <div className="dataTotalEntries"><p>Total Entries :{data?.length}</p></div>
                          <div className="filter_or_createcomponentn">

                          </div>
                        </div>
                      </div>
                      <div className="table-body bg-light p-0">
                        <div
                         ref={containerRef}
                         className={`table-responsive reuseableEditable ${
                           isScrollable ? "is-scrollable-table" : ""
                         }`}
                        
                        >
                          <table className='table p-0 m-0' id='dataTable'>
                            <thead>
                              <tr>
                                <th><input type="checkbox" className='' name="" id=""  checked={isAllChecked} onChange={handleCheckAll}/></th>
                                <th className='slno'>
                                  <img src={slno_icon} alt="noImg" className='headerIcon' />
                                SL No.</th>
                                {header?.map((headerItem) => {
                                    if (headerItem.key === "form_path") return null;
                                    const FaIcon =
                                      headerItem.faIcon ||
                                      (headerItem.key === "form_type" ? FaRegFileAlt : null) ||
                                      (headerItem.key === "release_status" ? FaRegCheckCircle : null);
                                    return (
                                        <th
                                            key={headerItem.key}
                                            onClick={() => handleSort(headerItem.key)}
                                            style={{ cursor: "pointer" }}
                                            className={headerItem.key === "release_status" ? "generated-form-status-col" : ""}
                                        >
                                            {headerItem.icon ? (
                                              <img src={headerItem.icon} alt="" className='headerIcon' />
                                            ) : FaIcon ? (
                                              <FaIcon className="headerIcon generated-form-header-fa" aria-hidden="true" />
                                            ) : null}
                                            {" "}{headerItem.value === "Client ID"? "Org ID":headerItem.value} {getSortIcon(headerItem.key) &&<img src={getSortIcon(headerItem.key)} alt="" className='arrow_img'/>}
                                        </th>
                                    );
                                })}
                                  <th className='action_dataIconheader generated-forms-action-header'><img src={action_icon} alt="noImg" className='headerIcon' />Action</th>
                              </tr>
                            </thead>
                                <tbody>
                                  {currentRecords.length > 0 ? (
                                    currentRecords.map((item, index) => (
                                      <tr key={item.id} data-id={item.id}>
                                        <td className="tabletdheight">
                                          <div className="table-td-div">
                                            <span>
                                            <input
                                              type="checkbox"
                                              className=''
                                              checked={checkedItems[item.id] || false}
                                              onChange={() => handleCheckChange(item.id)}
                                            />
                                            </span>
                                          </div>
                                        </td>
    
                                        <td className="tabletdheight slno" >
                                          <div className="table-td-div mt-1">
                                            {indexOfFirstRecord + index + 1}
                                          </div>
                                        </td>
    
                                        {header.map((headerItem) => {
  if (headerItem.key === "form_path") return null; // skip

  const content = item[headerItem.key];
  const letter = content?.charAt(0)?.toUpperCase() || "N";

  return (
    <td key={headerItem.key} className={`tabletdheight${headerItem.key === "release_status" ? " generated-form-status-col" : ""}`}>
      {headerItem.input === "date" ? (
        <span className="reuseableEditable-highlight-text role-Active-highlight-color">
          {content ? formatDate(content) : ""}
        </span>
      ) : headerItem.key === "unit_id" ? (
        <div className="d-flex align-items-center gap-2 reuseableEditable-avatar-circle-main">
          <div className="reuseableEditable-avatar-circle holiday-avater-color">
            {letter}
          </div>
          <span>{content}</span>
        </div>
      ) : headerItem.key === "release_status" ? (
        <span className={item.is_released ? "generated-form-status-released" : "generated-form-status-pending"}>
          {content}
        </span>
      ) : headerItem.dataIcon ? (
        <div className="d-flex align-items-center gap-2 reuseableEditable-avatar-circle-main">
          <div
            className="reuseableEditable-avatar-circle holiday-avater-color"
          >
            {letter}
          </div>
          {headerItem.highlightName ? (
            <span className="highlight-text">{content}</span>
          ) : (
            <span>{content}</span>
          )}
        </div>
      ) : (
        <>{content}</>
      )}
    </td>
  );
})}

              <td className="action_dataIcon generated-forms-action-cell">
                <div className="generated-forms-action-btns">
                                      {typeof handleViewPdfClick === "function" && (
                                        <span>
                                          <a
                                            href="#"
                                            title="View PDF"
                                            onClick={(e) => {
                                              e.preventDefault();
                                              handleViewPdfClick(item);
                                            }}
                                          ><FaEye/>
                                          </a>
                                        </span>
                                      )}
                                      <span className="mx-2">
                                        <a
                                          href="#"
                                          title="Download"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            handleDownloadClick(item.id);
                                          }}
                                        >
                                          <img className="generatedFormsDownloadicon" src={downloadIcon} alt="Download" />
                                        </a>
                                      </span>
                                      {typeof handleReleaseClick === "function" && !isClient && (
                                        <button
                                          type="button"
                                          className="generated-forms-release-btn"
                                          title={item.is_released ? "Re-release" : "Release"}
                                          onClick={() => handleReleaseClick(item)}
                                        >
                                          {item.is_released ? "Re-release" : "Release"}
                                        </button>
                                      )}
                </div>
                                    </td>
                                      </tr>
                                    ))
                                  ) : (
                                    <tr>
                                      <td
                                        colSpan={header.length + 2}
                                        className="text-center fs-3 fw-bold text-muted"
                                      >
                                        No Record Available
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
    
                          </table>
                        </div>
                        </div>
                      {/* </form> */}
                  <div className="col-md-12">
                  <div className="pagination align-items-center justify-content-between mt-3 row">
                    <div className="col-md-12 text-center">
                    <div>
                      {/* Prev button */}
                      <button
                        className="page-btn-arrow"
                        onClick={() => handlePageChange(currentPage - 1)}
                        disabled={currentPage === 1}
                      >
                        &lt;
                      </button>
    
                      {(() => {
                        const pages = [];
    
                        if (totalPages <= 10) {
                          // Show all pages if small count
                          for (let i = 1; i <= totalPages; i++) {
                            pages.push(i);
                          }
                        } else {
                          pages.push(1); // Always show first
    
                          // Left ellipsis
                          if (currentPage > 4) {
                            pages.push("...");
                          }
    
                          // Sliding window around current page
                          const start = Math.max(2, currentPage - 2);
                          const end = Math.min(totalPages - 1, currentPage + 2);
    
                          for (let i = start; i <= end; i++) {
                            pages.push(i);
                          }
    
                          // Right ellipsis
                          if (currentPage < totalPages - 3) {
                            pages.push("...");
                          }
    
                          pages.push(totalPages); // Always show last
                        }
    
                        return pages.map((p, idx) =>
                          p === "..." ? (
                            <span key={`ellipsis-${idx}`} className="ellipsis">
                              ...
                            </span>
                          ) : (
                            <button
                              key={p}
                              className={`page-btn ${currentPage === p ? "active" : ""}`}
                              onClick={() => handlePageChange(p)}
                            >
                              {p}
                            </button>
                          )
                        );
                      })()}
    
                      {/* Next button */}
                      <button
                        className="page-btn-arrow"
                        onClick={() => handlePageChange(currentPage + 1)}
                        disabled={currentPage === totalPages}
                      >
                        &gt;
                      </button>
                    </div>
    
                    </div>
    
                    <div className="col-md-12">
                    <div className="row float-end">
                    <div className="d-flex align-items-center showPerPage">
                      <span className="me-2">Show per page:</span>
                      <select
                        value={recordsPerPage}
                        onChange={(e) => {
                          setRecordsPerPage(Number(e.target.value));
                          setCurrentPage(1);
                        }}
                      >
                        {getPageSizeOptions(sortedData.length).map((size, i) => (
                          <option key={i} value={size}>
                            {size === sortedData.length ? "All" : size}
                          </option>
                        ))}
                      </select>
                    </div>
                    </div>
                    </div>
                  </div>
                  </div>
    
                </div>
              </div>
          </div>
        </div>
    )
}

export default GeneratedFormsModel
